// extracted by mini-css-extract-plugin
module.exports = {"modal":"AccountNeededModal_modal__38Nsv","modalOverlay":"AccountNeededModal_modalOverlay__2c4y_","title":"AccountNeededModal_title__3dK4t"};